import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";

const AddCategory = ({ title, onSubmit }) => {
  const route = all_routes;
  const [name, setName] = useState("");
  const handleFormSubmit = () => {
    if (onSubmit) {
      onSubmit(name);
    }
    setName("");
  };
  return (
    <>
      {/* Add Category */}
      <div className="modal fade" id="add-units-category" data-bs-backdrop="false" >
        {/* data-bs-backdrop="false" */}
        
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add New {title ? title : ""}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="modal-footer-btn">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link
                      to={route.addproduct}
                      className="btn btn-submit"
                      onClick={handleFormSubmit}
                      data-bs-dismiss="modal"
                    >
                      Submit
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Category */}
    </>
  );
};

export default AddCategory;
